exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#account[data-v-522a3f64]{margin:12px;margin-top:36px}#account .top[data-v-522a3f64]{margin-bottom:12px}#account .account .segment[data-v-522a3f64]:hover{background-color:#f5f5f5;cursor:pointer}#account .account .column[data-v-522a3f64]{font-size:large}#account .account .column .main[data-v-522a3f64]{font-weight:bold;margin-top:6px}#account .account .column .main i.icon[data-v-522a3f64]{margin-right:20px}", ""]);

// exports
